// extracted by mini-css-extract-plugin
export var sectionDivider = "styles-module__sectionDivider___P2mrv";
export var alreadyHaveAnAccount = "styles-module__alreadyHaveAnAccount___Us3Wa";